import { render, staticRenderFns } from "./Preview.vue?vue&type=template&id=596aa5b3&"
import script from "./Preview.vue?vue&type=script&lang=js&"
export * from "./Preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports